/**
 * Webchat attachment types (chat_attachments feature).
 * Mirror of the backend allowlist in backend/app/routers/media.py —
 * keep the two in sync.
 */
const MIME_ALLOWLIST = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
  'application/pdf',
  'text/plain',
  'text/markdown',
  'text/csv',
])

/** Extension fallbacks — browsers report unreliable MIME for text files. */
const EXT_MIME: Record<string, string> = {
  '.txt': 'text/plain',
  '.md': 'text/markdown',
  '.markdown': 'text/markdown',
  '.csv': 'text/csv',
}

export const ATTACHMENT_ACCEPT = [...MIME_ALLOWLIST, ...Object.keys(EXT_MIME)].join(',')

/** Effective MIME for a picked file, or null when the file isn't allowed. */
export function resolveAttachmentMime(file: File): string | null {
  if (MIME_ALLOWLIST.has(file.type)) return file.type
  const dot = file.name.lastIndexOf('.')
  if (dot === -1) return null
  return EXT_MIME[file.name.slice(dot).toLowerCase()] ?? null
}

/** FormData for /api/media/upload carrying the RESOLVED mime — browsers
 *  report unreliable file.type for text files, so re-wrap the File. */
export function createUploadFormData(file: File, resolvedMime: string): FormData {
  const fd = new FormData()
  fd.append('file', new File([file], file.name, { type: resolvedMime }), file.name)
  return fd
}

export function attachmentKind(mime: string): 'image' | 'document' {
  return mime.startsWith('image/') ? 'image' : 'document'
}
